import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import ProductNav from '../../common/ProductNav';
import { useState } from 'react';
import Bundles from '@elem/compPage/delta-3-max-series/pages/product/us/Bundles';
import CompatibilityTable from '@elem/compPage/delta-3-max-plus-portable-power-station/pages/compatibility/components/CompatibilityTable';
import { getCompatibilityData } from './config';

const Compatiblity: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('Compatiblity');
    const isEu = ['eu', 'uk', 'de', 'fr', 'es', 'it', 'nl'].includes(locale)
    const [activeTab, setActiveTab] = useState('Compatibility');

    const { compatibilityData, tableRows, mobileTableData, alsoLike, compatibilityDataEu, mobileTableDataEu } = getCompatibilityData();

    return (
        <section className={'d3m-specs'}>
            <ProductNav activeTab={activeTab} tabCallback={setActiveTab} />

            {activeTab === 'Bundles' && (
                <>
                    <Bundles />
                </>
            )}

            {activeTab === 'Compatibility' && (
                <>
                    <CompatibilityTable data={isEu ? compatibilityDataEu : compatibilityData} rows={tableRows} mobileTableData={isEu ? mobileTableDataEu : mobileTableData} alsoLike={alsoLike} showAlsoLike={false} />
                </>
            )}
        </section>
    );
};

export default Compatiblity;
